import React from 'react';
import { B, D, Arr, Lbl } from '../shared/SvgHelpers';

export default function DiagramEmailE2E() {
  return (
    <div className="space-y-3">
      <h4 className="text-sm font-bold text-blue-700">2. E-Mail-Reklamation -- End-to-End</h4>
      <p className="text-xs text-slate-500">Vom E-Mail-Eingang bis zur Bestatigungs-E-Mail an den Kunden.</p>
      <svg viewBox="0 0 750 390" className="w-full rounded-lg border border-slate-200" style={{ background: '#fafbfc' }}>
        {/* Zeile 1: Eingang */}
        <B x={10} y={15} w={95} h={48} label={"Kunden-\nE-Mail"} color="#2563eb" sub="IMAP Postfach" />
        <Arr x1={105} y1={39} x2={135} y2={39} />
        <B x={135} y={15} w={85} h={48} label={"Polling\nalle 10s"} color="#4f46e5" sub="asyncio" />
        <Arr x1={220} y1={39} x2={255} y2={39} />

        <D x={295} y={39} s={30} label={"Bereits\nbekannt?"} color="#d97706" />
        <Lbl x={328} y={32} text="Ja" color="#16a34a" />
        <Arr x1={325} y1={39} x2={365} y2={39} />
        <B x={365} y={15} w={100} h={48} label={"Duplikat\nignorieren"} color="#64748b" sub="message_id Check" />

        <Arr x1={295} y1={69} x2={295} y2={98} />
        <Lbl x={302} y={88} text="Nein (Neu)" color="#dc2626" />

        {/* Zeile 2: KI Extraktion */}
        <B x={245} y={98} w={100} h={48} label={"KI Daten-\nextraktion"} color="#7c3aed" sub="Prompt P09" />
        <Arr x1={345} y1={122} x2={385} y2={122} />

        <D x={425} y={122} s={32} label={"Bestehende\nReklamation?"} color="#0891b2" />
        <Arr x1={457} y1={122} x2={500} y2={122} />
        <Lbl x={463} y={114} text="Ja" color="#16a34a" />
        <B x={500} y={98} w={105} h={48} label={"Automatisch\nzuordnen"} color="#16a34a" sub="Nr/Token/E-Mail" />
        <Arr x1={605} y1={122} x2={645} y2={122} />
        <B x={645} y={98} w={80} h={48} label={"In D0\narchiviert"} color="#16a34a" r={8} />

        <Arr x1={425} y1={154} x2={425} y2={185} />
        <Lbl x={432} y={176} text="Nein (Neues Ticket)" color="#dc2626" size={7.5} />

        {/* Zeile 3: Neues Ticket */}
        <B x={375} y={185} w={100} h={48} label={"Ticket\nerstellen"} color="#d97706" sub="Token generieren" />
        <Arr x1={475} y1={209} x2={520} y2={209} />

        <D x={558} y={209} s={32} label={"Daten\nvollst.?"} color="#d97706" />

        {/* Ja-Pfad */}
        <Arr x1={590} y1={209} x2={635} y2={209} />
        <Lbl x={596} y={200} text="Ja" color="#16a34a" />
        <B x={635} y={188} w={90} h={42} label={"Reklamation\nanlegen"} color="#16a34a" />
        <Arr x1={680} y1={230} x2={680} y2={258} />
        <B x={635} y={258} w={90} h={38} label={"Bestatigungs-\nE-Mail (KI)"} color="#16a34a" sub="mit Rekl.-Nr." />
        <Arr x1={680} y1={296} x2={680} y2={322} />
        <B x={635} y={322} w={90} h={38} label={"PDF in D0\narchiviert"} color="#16a34a" />

        {/* Nein-Pfad */}
        <Arr x1={558} y1={241} x2={558} y2={268} />
        <Lbl x={565} y={260} text="Nein" color="#dc2626" />
        <B x={505} y={268} w={106} h={48} label={"Ruckfrage-\nE-Mail senden"} color="#dc2626" sub="fehlende Felder" />
        <Arr x1={558} y1={316} x2={558} y2={338} />

        {/* Offentliches Formular */}
        <B x={495} y={338} w={126} h={38} label={"Offentliches Formular\n(Token-Link)"} color="#0891b2" />

        {/* Kunde antwortet */}
        <Arr x1={495} y1={357} x2={385} y2={357} />
        <B x={295} y={338} w={90} h={38} label={"Kunde\nantwortet"} color="#2563eb" />
        <Arr x1={340} y1={338} x2={340} y2={310} />

        {/* Zuruck zur Datenprufung */}
        <D x={340} y={285} s={22} label="Komplett?" color="#d97706" />
        <Arr x1={362} y1={285} x2={635} y2={225} />
        <Lbl x={375} y={278} text="Ja → Reklamation" color="#16a34a" size={7.5} />
        <Arr x1={340} y1={263} x2={340} y2={242} />
        <Lbl x={285} y={252} text="Nein → erneute Ruckfrage" color="#dc2626" size={7.5} />

        {/* Benachrichtigung */}
        <B x={15} y={322} w={105} h={42} label={"In-App\nBenachrichtigung"} color="#d97706" sub="Glocke" />
        <Arr x1={120} y1={343} x2={295} y2={343} dashed color="#d97706" />
      </svg>
    </div>
  );
}
